import {Component} from '@angular/core';
import {ButtonSeverity} from 'primeng/button';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';
import {IBaseModalComponent} from '../../components/ibase-modal/ibase-modal.component';
import {PrimeNgImportsModule} from '../../prime-ng-imports';

export class ConfirmationModalConfig {
    constructor(
        public title = 'Confirmation warning',
        public message = 'Do you want to proceed?',
        public severity?: ButtonSeverity,
        public confirmationConfig: ConfirmationModalResponseConfig = {
            label: 'Confirm',
            severity: 'primary',
            icon: 'pi pi-check'
        },
        public cancelConfig: ConfirmationModalResponseConfig = {
            label: 'Cancel',
            severity: 'secondary',
            icon: 'pi pi-times'
        }
    ) {}
}

export class ConfirmationModalResponseConfig {
    constructor(
        public label: string,
        public severity?: ButtonSeverity,
        public icon?: string
    ) {}
}

@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss'],
    imports: [PrimeNgImportsModule]
})
export class ConfirmationModalComponent extends IBaseModalComponent<
    ConfirmationModalComponent,
    ConfirmationModalConfig
> {
    protected get _messages(): string[] {
        return this.config.data?.message.split('\n') ?? [];
    }
    protected get _severity(): ButtonSeverity | undefined {
        return this.config.data?.severity;
    }

    /**
     * Returns the dialog service parameters for this modal.
     */
    public static getDialogServiceParameters(
        config: ConfirmationModalConfig
    ): DynamicDialogConfig<ConfirmationModalConfig> {
        return {
            modal: true,
            header: config.title,
            data: config,
            closable: false,
            resizable: false
        };
    }

    /**
     * Called when the modal is ready.
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onReady(): Promise<void> {}

    /**
     * Called when the modal is destroyed.
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}

    /**
     * Called when the cancel button is clicked.
     */
    protected onCancel() {
        this.ref.close(false);
    }

    /**
     * Called when the confirm button is clicked.
     */
    protected onConfirm() {
        this.ref.close(true);
    }
}
